// extracted by mini-css-extract-plugin
export default {"container":"ProductCard_container__Eo0Cj","info":"ProductCard_info__V989m"};